<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeDialog" class="goodsList-dialog">
            <div>
                <div class="flex_between_middle mb-20">
                    <div class="flex gap20">
                        <div class="flex_center_middle gap10">
                            <span class="flex_shrink0">产品名称</span>
                            <el-input placeholder="请输入产品名称" size="small" v-model="ProductFindDTO.category" clearable></el-input>
                        </div>
                        <div class="flex_center_middle gap10">
                            <span class="flex_shrink0">产品类别</span>
                            <el-input placeholder="请输入产品类别" size="small" v-model="ProductFindDTO.subclass" clearable></el-input>
                        </div>
                    </div>
                    <div>
                        <el-button type="primary" size="small" @click="getList">搜索</el-button>
                    </div>
                </div>
                <el-table
                    :data="tableData"
                    stripe
                    border
                    ref="tableData"
                    style="width: 100%"
                    @select="handleSelect"
                    @select-all="handleAllSelect"

                >
                    <el-table-column
                        type="selection"
                        align="center"
                        width="55"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        width="180"
                        label="选择数量"
                    >
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.num" :min="1" size="small"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="category"
                        align="center"
                        label="产品名称"
                    ></el-table-column>
                    <el-table-column
                        prop="listPrice"
                        align="center"
                        label="单价">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.listPrice" size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="subclass"
                        align="center"
                        label="产品类别"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.subclass" size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="thumbnailPath"
                        label="缩略图"
                        align="center"
                        width="130" >
                        <template slot-scope="scope">
                            <el-popover placement="top-start" trigger="click">
                                <!--trigger属性值：hover、click、focus 和 manual-->
                                <a :href="scope.row.thumbnailPath"  target="_blank" title="查看最大化图片">
                                    <img :src="scope.row.thumbnailPath" style="max-height: 800px;max-width: 800px">
                                </a>
                                <img slot="reference" :src="scope.row.thumbnailPath" style="max-height: 50px;max-width: 50px cursor:pointer">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="subclass"
                        align="center"
                        label="工艺要求"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.processRequirements" size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="subclass"
                        align="center"
                        label="备注"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remarks" size="small"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="number"
                        align="center"
                        label="产品编号"
                        width="180"
                    ></el-table-column>
                    <el-table-column
                        prop="unit"
                        align="center"
                        label="单位"
                    ></el-table-column>
                    <el-table-column
                        prop="specifications"
                        align="center"
                        label="规格"
                    ></el-table-column>
                    <el-table-column
                        prop="boringList"
                        align="center"
                        label="文件清单"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="nature"
                        align="center"
                        label="产品性质"
                        width="100"
                    >     <template slot-scope="scope">
                        <el-tag type=" info" v-if="scope.row.nature==='0'">常规产品</el-tag>
                        <el-tag type="success" v-if="scope.row.nature==='1'">标准件</el-tag>
                    </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination">

                <el-pagination
                    :current-page="form.currentPage"
                    :page-sizes="[10, 30, 50, 100]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="form.total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
            <el-button class="submit-button" @click="submit" type="primary">确定</el-button>
        </el-dialog>
    </div>

</template>

<script>
import {productSelectInfo} from '@/api/order/product'
export default {
    data() {
        return {
            form: {
                currentPage:1,
                pageSize:10,
                total:0,
            },
            ProductFindDTO:{
                fileName:'',
                materialType:'',
                startTime: '',
                endTime: '',
                access: '',
                name:'',
                number:'',
                category:'',
                subclass:'',
                nature:'',
            },
            dialogVisible: false,
            tableData: [],
            submitData:[],
            ids:[],
        }
    },
    methods: {
        visible(data) {
            //保存父组件传的值
            this.ProductFindDTO.access = localStorage.getItem("access")
            this.ids = (data && JSON.parse(JSON.stringify(data))) || []
            console.log(this.parentData)
            this.dialogVisible = true
            this.getList()
        },
        getList(){
            //过滤搜索项
            const {currentPage,pageSize} = this.form
            productSelectInfo(currentPage, pageSize,this.ProductFindDTO).then((res) => {
                res.data.data.records.forEach(item=>{
                    if(!item.num) this.$set(item,'num',1)
                    if(!item.processRequirements) this.$set(item,'processRequirements','')
                    if(!item.remarks) this.$set(item,'remarks','')
                })
                this.tableData = res.data.data.records
                this.form.total = Number(res.data.data.total)
                this.$nextTick(()=>{
                    this.tableData.forEach(item=>{
                        // const flag = this.recipient.find(child=>child.id === item.id)
                        const flag = this.ids.find(child=>child.id === item.id)
                        if(flag){
                            this.$set(item,'num',flag.num)
                            this.$set(item,'listPrice',flag.listPrice)
                            this.$set(item,'subclass',flag.subclass)
                            this.$set(item,'processRequirements',flag.subclass)
                            this.$set(item,'remarks',flag.subclass)

                            this.$refs["tableData"].toggleRowSelection(item)
                        }
                    })
                })
            })
        },
        submit(){
            this.$emit('chooseGoods',this.ids)
            this.closeDialog()
        },
        closeDialog(){
            this.ProductFindDTO = {
                fileName:'',
                materialType:'',
                startTime: '',
                endTime: '',
                access: '',
                name:'',
                number:'',
                category:'',
                subclass:'',
                nature:'',
            }
            this.dialogVisible = false
        },
        handleSizeChange(val){
            this.form.pageSize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.form.currentPage = val
            this.getList()
        },
        // 将获取到的id存入ids中
        handleSelect(selection, row){
            const isSelect = selection.find(item=>item.id === row.id)
            if(isSelect){
                this.ids.push(row)
            }else{
                const index = this.ids.findIndex(item=>item.id === row.id)
                this.ids.splice(index,1)
            }
        },
        handleAllSelect(selection){
            if(selection.length){
                selection.forEach(item=>{
                    const flag = this.ids.find(child=>item.id === child.id)
                    if(!flag) this.ids.push(item)
                })
            }else{
                this.gridData.forEach(item=>{
                    const index = this.ids.findIndex(child=>child.id === item.id)
                    this.ids.splice(index,1)
                })
            }
        },

    }
}
</script>

<style scoped>
.flex{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}
.submit-button{
    margin: auto ;
    display: flex;
}
.el-pagination{
    text-align: right;
    margin: 20px 0;
}
::v-deep.goodsList-dialog .el-dialog{
    width: 80%;
}
</style>
